var React = require('react');

function CloseLarge (props) {
    return React.createElement("svg",props,React.createElement("path",{"transform":"rotate(45 12 12)","d":"M13.5 11H23a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1h-9.5V23a1 1 0 0 1-1 1H12a1 1 0 0 1-1-1v-9.5H1a1 1 0 0 1-1-1V12a1 1 0 0 1 1-1h10V1a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v10z","fill":"currentColor"}));
}

CloseLarge.defaultProps = {"width":"25","height":"25"};

module.exports = CloseLarge;

CloseLarge.default = CloseLarge;
